<!-- intro-page.component.html (FULL DROP-IN) -->

<header class="cta"></header>

<main class="intro" aria-label="Doctogenic introduction">
  <article class="page intro-page" aria-label="Doctogenic landing sheet">
    <!-- CLICKABLE / PRESSABLE BANNER (scroll to top) -->
    <header class="page-title intro-title" [class.at-top]="atTop" aria-label="Scroll to top" role="button" tabindex="0"
      title="Scroll to top" (click)="onTitleClick($event)" (keydown.enter)="onTitleClick($event)"
      (keydown.space)="onTitleClick($event)">
      <h1 class="intro-brand">doctogenic</h1>
      <p class="intro-definition">&mdash;literally, “to make doctors”</p>

      <svg class="to-top-icon" viewBox="0 0 24 24" aria-hidden="true">
        <!-- top boundary line -->
        <path d="M4 5h16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <!-- up arrow -->
        <path d="M12 19V9m0 0l-5 5m5-5l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </header>

    <div class="page-body intro-body">
      <!-- ===================== GET STARTED (NOT CLICKABLE) ===================== -->
      <section class="get-started" aria-label="Get started">
        <div class="get-started-left">
          <h2 class="get-started-title">Get started</h2>
          <p class="get-started-hint">{{ hintText }}</p>
        </div>

        <div class="get-started-actions">
          <button type="button" class="btn btn-primary btn-pill" (click)="onExampleClick($event)"
            title="Try a random biochemistry condition">
            Try an example
          </button>
        </div>
      </section>

      <!-- ===================== OVERVIEW ===================== -->
      <section class="overview" aria-label="Overview">
        <h2 class="overview-title">A USMLE Step 1 study resource</h2>

        <p class="lede">
          Doctogenic is a reference for medical students as they learn course material and prepare for board exams
          (USMLE Step 1 available first, with Step 2 added later).
        </p>

        <p class="lede">
          Each condition (disease, syndrome, injury, or other clinical entity) presents a concise overview and key
          points—causes and mechanisms, symptoms and signs, diagnostic findings, and treatment/prevention—using a
          consistent section layout across the library to make side-by-side comparison easier.
        </p>

        <p class="lede">
          This site is not a question bank or a flashcard system. It's for understanding and review—linking mechanisms
          to clinical presentation, workup, and management.
        </p>
      </section>

      <div class="feature-grid" role="list" aria-label="Key features">
        <section class="feature-card" role="listitem" aria-label="Standardized structure">
          <h3 class="feature-title">Comparable sections</h3>
          <p class="feature-text">
            Each condition uses the same headings, which makes it easier to build a consistent mental model and compare
            topics.
          </p>
        </section>

        <section class="feature-card" role="listitem" aria-label="From presentation to plan">
          <h3 class="feature-title">Clinical framing</h3>
          <p class="feature-text">
            Coverage includes presentation, exam, workup, and management alongside the underlying physiology.
          </p>
        </section>

        <section class="feature-card" role="listitem" aria-label="Differentials that teach distinction">
          <h3 class="feature-title">Differentials with distinguishing findings</h3>
          <p class="feature-text">
            Common alternatives are listed with the specific history, exam, lab, and imaging findings that distinguish
            them.
          </p>
        </section>
      </div>

      <section class="structure" aria-label="Each condition includes">
        <h3 class="section-title">Each condition includes</h3>
        <ul class="section-list">
          <li><strong>Overview:</strong> plain-language + clinical definitions</li>
          <li><strong>Timeline:</strong> inciting event, latency period, diagnostic delay</li>
          <li><strong>Patient population:</strong> who gets it, when it presents</li>
          <li><strong>Clinical presentation:</strong> signs/symptoms, HPI, exam</li>
          <li><strong>Diagnostic workup:</strong> criteria, labs, imaging</li>
          <li><strong>Pathophysiology:</strong> key mechanisms, organ involvement</li>
          <li><strong>Treatment:</strong> pharm + non-pharm, contraindications</li>
          <li><strong>Prevention:</strong> pharm + non-pharm</li>
          <li><strong>Outcomes &amp; complications:</strong> short- and long-term</li>
          <li><strong>Differentials:</strong> how to distinguish similar entities</li>
        </ul>
      </section>
    </div>

    <footer class="page-footer">
      <p>
        <strong>Medical Disclaimer:</strong>
        The content on this site is for educational purposes only and is not a substitute for professional medical
        advice, diagnosis, or treatment. If you think you may be experiencing a medical emergency, call 911 or your
        local emergency number immediately. Always consult a licensed healthcare professional with questions about a
        medical condition.
      </p>

      <p>
        <strong>Artificial Intelligence Use:</strong>
        Portions of this site's content were generated or assisted by AI and reviewed by Erik Romano, MD; however,
        errors or omissions may occur.
      </p>

      <p>
        <strong>USMLE®</strong> is a registered trademark of the Federation of State Medical Boards (FSMB) and the
        National Board of Medical Examiners (NBME). Doctogenic and Roscoe &amp; Romano are not affiliated with,
        sponsored by, or endorsed by the USMLE, FSMB, or NBME. Neither FSMB nor NBME has reviewed or approved this
        content. “USMLE Step 1” and “USMLE Step 2 CK” are used only to identify the relevant examinations.
      </p>

      <p class="copyright">© 2026 Roscoe &amp; Romano. All rights reserved.</p>
    </footer>
  </article>
</main>
